import React, { useState } from 'react';
import { CreateEventUserInput, Event, EventRoleEnum } from './API';
import { addUserToEvent } from './mutations/processCreateEventUser';
import { Button, Input, EmailIcon, Select } from '@uclaea/react-component-library';
import './css/Modal.css';
import { VALID_EMAIL_DOMAIN } from './constants/config';

const roleOptions = [
  { label: 'Team', id: 'team', value: EventRoleEnum.TEAM },
  { label: 'Co-owner', id: 'coowner', value: EventRoleEnum.COOWNER },
];

interface AddUserProps {
  eventDetails: Event;
  onClose: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}

const AddUser: React.FC<AddUserProps> = ({ eventDetails, onClose, onSuccess, onError }) => {
  const [email, setEmail] = useState<string>('');
  const [eventRole, setEventRole] = useState<EventRoleEnum>(EventRoleEnum.TEAM);
  const [emailError, setEmailError] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (!email.includes(VALID_EMAIL_DOMAIN)) {
      setEmailError('Email must be a valid UCLA email address (contain "ucla.edu").');
      return;
    }
    setEmailError(null);
    const { eventId } = eventDetails;

    const addUserSubmitData: CreateEventUserInput = {
      eventId,
      ownerEmail: email,
      eventRole,
    };

    try {
      const result = await addUserToEvent(addUserSubmitData);
      console.log('Event user created:', result);
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error('Error creating event user:', err);
      alert('Failed to add the user to the event. Please try again.');
      if (onError) onError();
    }
  };

  const onSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit().catch((err) => {
      console.error('Failed to submit form:', err);
      alert('An unexpected error occurred. Please try again.');
      if (onError) onError();
    });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Add User to {eventDetails.eventName}</h2>
        <p>
          Give team members permissions to manage check-ins using this App.
          <br />
          Email must be associated with a valid UCLA LOGON account.
          <br />
          To create an account visit <a href='https://accounts.iam.ucla.edu/register' target="_blank" rel="noopener noreferrer">UCLA IAM</a>.
        </p>
        <form onSubmit={onSubmitHandler}>
          <Input
            label="User Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            placeholder="Enter user email"
            required
            icon={{ left: EmailIcon }}
            error={emailError ?? undefined}
          />
          <br />
          <Select
            label="Role"
            value={eventRole}
            onChange={(e) => setEventRole(e.target.value as EventRoleEnum)}
            options={roleOptions}
            required
          />
          <br />
          <Button variant="primary" label="Invite" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default AddUser;
